// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ev-F","colMin":"styles_colMin__37Qg2"};